export default __webpack_public_path__ + "static/media/dashboard_arrow_circle.be022625.svg";